import { APP_BASE_URL } from "../../config/api";
const BASE = `${APP_BASE_URL}/admin/sub-entities`;
// Function to fetch the list of sub-entities from the backend API
export async function listSubEntities(entity_id) {
  try {
    const response = await fetch(`${BASE}/admin/sub-entities/${entity_id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch sub-entities');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    return [];
  }
}